import React, { useEffect, useState, useRef } from 'react';
import { SOCIAL_PROOF_EVENTS } from '../utils/mockData';

function timeAgo(ms) {
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s ago`;
  return `${Math.floor(s / 60)}m ago`;
}

export default function SocialProofTicker() {
  const [current, setCurrent] = useState(null);
  const [visible, setVisible] = useState(false);
  const queueRef = useRef([...SOCIAL_PROOF_EVENTS].sort(() => Math.random() - 0.5));
  const idxRef = useRef(0);

  useEffect(() => {
    const initial = setTimeout(() => showNext(), 3000 + Math.random() * 4000);
    return () => clearTimeout(initial);
  }, []);

  const showNext = () => {
    const events = queueRef.current;
    const ev = events[idxRef.current % events.length];
    idxRef.current += 1;
    const shownAt = Date.now();
    setVisible(false);
    setTimeout(() => { setCurrent({ ...ev, shownAt }); setVisible(true); }, 350);
    const jitter = ev.delayMs * 0.2 * (Math.random() - 0.5);
    setTimeout(() => showNext(), ev.delayMs + jitter);
  };

  if (!current) return null;

  return (
    <div className="fixed bottom-20 left-4 z-30 pointer-events-none">
      <div className="flex items-center gap-3 px-4 py-3 rounded-xl max-w-[310px]"
        style={{
          background: 'rgba(8,0,18,0.96)', border: '1px solid rgba(255,0,200,0.25)',
          boxShadow: '0 0 20px rgba(255,0,200,0.1)',
          transition: 'opacity 0.35s ease,transform 0.35s ease',
          opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(10px)',
        }}>
        <div className="w-2 h-2 rounded-full bg-green-400 shrink-0" style={{ boxShadow: '0 0 6px #00ff88' }} />
        <div>
          <div className="text-white font-bold leading-snug" style={{ fontSize: '14px' }}>
            <span style={{ color: '#ff00cc' }}>{current.name}</span> {current.action}
          </div>
          <div className="text-gray-500 mt-0.5" style={{ fontSize: '12px' }}>
            {current.location} · just now
          </div>
        </div>
      </div>
    </div>
  );
}